import axios from "axios";

const instance = () =>
  axios.create({
    baseURL: process.env.REACT_APP_VC_API_URL,
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

export default instance;
